/*
 *
 *  actions
 *
 */

import {
  CREATE_FOLLOW_RECORD,
  CREATE_FOLLOW_RECORD_SUCCESS,
  CREATE_FOLLOW_RECORD_ERROR,
  LOAD_RECORDS_META_DATA,
  LOAD_RECORDS_META_DATA_SUCCESS,
  LOAD_RECORDS_META_DATA_ERROR,
  LOAD_RECORDS_FOLLOW_HISTORY_RECORD,
  LOAD_RECORDS_FOLLOW_HISTORY_RECORD_SUCCESS,
  LOAD_RECORDS_FOLLOW_HISTORY_RECORD_ERROR,
  UPDATE_FOLLOW_RECORD,
  UPDATE_FOLLOW_RECORD_SUCCESS,
  UPDATE_FOLLOW_RECORD_ERROR,
  LOAD_RECORDS_ATTACHMENT_DETAIL_RECORD,
  LOAD_RECORDS_ATTACHMENT_DETAIL_RECORD_SUCCESS,
  LOAD_RECORDS_ATTACHMENT_DETAIL_RECORD_ERROR,
  UPLOAD_FOLLOW_ATTACHMENT_RECORD,
  UPLOAD_FOLLOW_ATTACHMENT_RECORD_SUCCESS,
  UPLOAD_FOLLOW_ATTACHMENT_RECORD_ERROR,
  FILE_UPLOAD_FOLLOW_ATTACHMENT_RECORD,
  FILE_UPLOAD_FOLLOW_ATTACHMENT_RECORD_SUCCESS,
  FILE_UPLOAD_FOLLOW_ATTACHMENT_RECORD_ERROR,
  LOAD_RECORDS_VALID_CACHE,
  ADD_REJECT,
  ADD_REJECT_SUCCESS,
  ADD_REJECT_ERROR,
  LOAD_RECORDS_LEADCARRYFORWARDLIST_RECORD,
  LOAD_RECORDS_LEADCARRYFORWARDLIST_RECORD_SUCCESS,
  LOAD_RECORDS_LEADCARRYFORWARDLIST_RECORD_ERROR,
  LOAD_FOLLOWUP_HISTORY,
  LOAD_FOLLOWUP_HISTORY_SUCCESS,
  LOAD_FOLLOWUP_HISTORY_ERROR,
  LOAD_FOLLOWUP_DETAILS_CRON,
  LOAD_FOLLOWUP_DETAILS_CRON_SUCCESS,
  LOAD_FOLLOWUP_DETAILS_CRON_ERROR,
  LOAD_FOLLOWUP_DETAILS,
  LOAD_FOLLOWUP_DETAILS_SUCCESS,
  LOAD_FOLLOWUP_DETAILS_ERROR,
  LOAD_REJECT_REASON_LIST,
  LOAD_REJECT_REASON_LIST_SUCCESS,
  LOAD_REJECT_REASON_LIST_ERROR,
  COMPANY_META_DATA,
  COMPANY_META_DATA_SUCCESS,
  COMPANY_META_DATA_ERROR,
} from "./constants"

export function loadRecordsCacheHit() {
  return {
    type: LOAD_RECORDS_VALID_CACHE,
  }
}

export function createFollowupRecord(record) {
  return {
    type: CREATE_FOLLOW_RECORD,
    record,
  }
}

export function createFollowupRecordSuccess(record, success) {
  return {
    type: CREATE_FOLLOW_RECORD_SUCCESS,
    record: record,
    success: success,
  }
}

export function createFollowupRecordError(error) {
  return {
    type: CREATE_FOLLOW_RECORD_ERROR,
    error,
  }
}

export function updateFollowupRecord(record) {
  return {
    type: UPDATE_FOLLOW_RECORD,
    record,
  }
}

export function updateClientProfileRecordSuccess(record, success) {
  return {
    type: UPDATE_FOLLOW_RECORD_SUCCESS,
    record: record,
    success,
  }
}

export function updateClientProfileRecordError(error) {
  return {
    type: UPDATE_FOLLOW_RECORD_ERROR,
    error,
  }
}

export function loadRecordsMetaData(leadDetail) {
  return {
    type: LOAD_RECORDS_META_DATA,
    leadDetail,
  }
}

export function loadRecordsMetaDataSuccess(followupRecordsMetaData) {
  return {
    type: LOAD_RECORDS_META_DATA_SUCCESS,
    followupRecordsMetaData,
  }
}

export function loadRecordsMetaDataError(error) {
  return {
    type: LOAD_RECORDS_META_DATA_ERROR,
    error,
  }
}
export function loadCompanyMetaData() {
  return {
    type: COMPANY_META_DATA,
  }
}

export function loadCompanyMetaDataSuccess(companyMetaData) {
  return {
    type: COMPANY_META_DATA_SUCCESS,
    companyMetaData,
  }
}

export function loadCompanyMetaDataError(error) {
  return {
    type: COMPANY_META_DATA_ERROR,
    error,
  }
}

//Followup Details
export function loadFollowupDetails(id) {
  return {
    type: LOAD_FOLLOWUP_DETAILS,
    id,
  }
}

export function loadFollowupDetailsSuccess(followup_details) {
  return {
    type: LOAD_FOLLOWUP_DETAILS_SUCCESS,
    followup_details,
  }
}

export function loadFollowupDetailsError(error) {
  return {
    type: LOAD_FOLLOWUP_DETAILS_ERROR,
    error,
  }
}

//Reject Reason
export function loadRejectReasonDetails() {
  return {
    type: LOAD_REJECT_REASON_LIST,
  }
}

export function loadRejectReasonDetailsSuccess(reject_reason, success) {
  return {
    type: LOAD_REJECT_REASON_LIST_SUCCESS,
    reject_reason,
    success,
  }
}

export function loadRejectReasonDetailsError(error) {
  return {
    type: LOAD_REJECT_REASON_LIST_ERROR,
    error,
  }
}
//Followup history
export function loadFollowHistoryDetails(id) {
  return {
    type: LOAD_FOLLOWUP_HISTORY,
    id,
  }
}

export function loadFollowHistoryDetailsSuccess(followup_history) {
  return {
    type: LOAD_FOLLOWUP_HISTORY_SUCCESS,
    followup_history,
  }
}

export function loadFollowHistoryDetailsError(error) {
  return {
    type: LOAD_FOLLOWUP_HISTORY_ERROR,
    error,
  }
}

export function loadRecordsFollowHistoryRecordData(leadDetail) {
  return {
    type: LOAD_RECORDS_FOLLOW_HISTORY_RECORD,
    leadDetail,
  }
}

export function loadRecordsFollowHistoryRecordDataSuccess(
  followupRecordsMetaData
) {
  return {
    type: LOAD_RECORDS_FOLLOW_HISTORY_RECORD_SUCCESS,
    followupRecordsMetaData,
  }
}

export function loadRecordsFollowHistoryRecordDataError(error) {
  return {
    type: LOAD_RECORDS_FOLLOW_HISTORY_RECORD_ERROR,
    error,
  }
}

export function loadRecordsAttachmentDetailData() {
  return {
    type: LOAD_RECORDS_ATTACHMENT_DETAIL_RECORD,
  }
}

export function loadRecordsAttachmentDetailDataSuccess(attachmentRecord) {
  return {
    type: LOAD_RECORDS_ATTACHMENT_DETAIL_RECORD_SUCCESS,
    attachmentRecord,
  }
}

export function loadRecordsAttachmentDetailDataError(error) {
  return {
    type: LOAD_RECORDS_ATTACHMENT_DETAIL_RECORD_ERROR,
    error,
  }
}

// Upload Attachment
export function uploadFollowupAttachmentRecordData(uploadRecord) {
  return {
    type: UPLOAD_FOLLOW_ATTACHMENT_RECORD,
    uploadRecord,
  }
}

export function uploadFollowupAttachmentRecordDataSuccess(uploadRecord) {
  return {
    type: UPLOAD_FOLLOW_ATTACHMENT_RECORD_SUCCESS,
    uploadRecord,
  }
}

export function uploadFollowupAttachmentRecordDataError(error) {
  return {
    type: UPLOAD_FOLLOW_ATTACHMENT_RECORD_ERROR,
    error,
  }
}

export function fileUploadFollowupAttachmentRecordData(fileUploadRecord) {
  return {
    type: FILE_UPLOAD_FOLLOW_ATTACHMENT_RECORD,
    fileUploadRecord,
  }
}

export function fileUploadFollowupAttachmentRecordDataSuccess(
  fileUploadRecord
) {
  return {
    type: FILE_UPLOAD_FOLLOW_ATTACHMENT_RECORD_SUCCESS,
    fileUploadRecord,
  }
}

export function fileUploadFollowupAttachmentRecordDataError(error) {
  return {
    type: FILE_UPLOAD_FOLLOW_ATTACHMENT_RECORD_ERROR,
    error,
  }
}

//REJECT
export function addRejectStatus(reject_Status) {
  return {
    type: ADD_REJECT,
    reject_Status,
  }
}
export function addRejectStatusSuccess(reject_Status) {
  return {
    type: ADD_REJECT_SUCCESS,
    reject_Status,
  }
}
export function addRejectStatusError(error) {
  return {
    type: ADD_REJECT_ERROR,
    error,
  }
}

//Lead Carry Forward
export function loadRecordsLeadCarryForwardListData(leadCarryForwardDetail) {
  return {
    type: LOAD_RECORDS_LEADCARRYFORWARDLIST_RECORD,
    leadCarryForwardDetail,
  }
}

export function loadRecordsLeadCarryForwardListDataSuccess(
  leadCarryForwardList
) {
  return {
    type: LOAD_RECORDS_LEADCARRYFORWARDLIST_RECORD_SUCCESS,
    leadCarryForwardList,
  }
}

export function loadRecordsLeadCarryForwardListDataError(error) {
  return {
    type: LOAD_RECORDS_LEADCARRYFORWARDLIST_RECORD_ERROR,
    error,
  }
}

//Followup Update Cron
export function loadFollowCronDetails(id) {
  return {
    type: LOAD_FOLLOWUP_DETAILS_CRON,
    id,
  }
}

export function loadFollowCronDetailsSuccess(followup_cron_details) {
  return {
    type: LOAD_FOLLOWUP_DETAILS_CRON_SUCCESS,
    followup_cron_details,
  }
}

export function loadFollowCronDetailsError(error) {
  return {
    type: LOAD_FOLLOWUP_DETAILS_CRON_ERROR,
    error,
  }
}

const actions = {
  createFollowupRecord,
  createFollowupRecordSuccess,
  createFollowupRecordError,

  updateFollowupRecord,
  updateClientProfileRecordSuccess,
  updateClientProfileRecordError,

  loadRecordsFollowHistoryRecordData,
  loadRecordsFollowHistoryRecordDataSuccess,
  loadRecordsFollowHistoryRecordDataError,

  loadRecordsMetaData,
  loadRecordsMetaDataSuccess,
  loadRecordsMetaDataError,
  loadCompanyMetaData,
  loadCompanyMetaDataSuccess,
  loadCompanyMetaDataError,

  loadRecordsAttachmentDetailData,
  loadRecordsAttachmentDetailDataSuccess,
  loadRecordsAttachmentDetailDataError,

  uploadFollowupAttachmentRecordData,
  uploadFollowupAttachmentRecordDataSuccess,
  uploadFollowupAttachmentRecordDataError,

  fileUploadFollowupAttachmentRecordData,
  fileUploadFollowupAttachmentRecordDataSuccess,
  fileUploadFollowupAttachmentRecordDataError,

  loadRecordsCacheHit,

  addRejectStatus,
  addRejectStatusSuccess,
  addRejectStatusError,

  loadRecordsLeadCarryForwardListData,
  loadRecordsLeadCarryForwardListDataSuccess,
  loadRecordsLeadCarryForwardListDataError,

  //Followup history

  loadFollowupDetails,
  loadFollowupDetailsSuccess,
  loadFollowupDetailsError,

  loadRejectReasonDetails,
  loadRejectReasonDetailsSuccess,
  loadRejectReasonDetailsError,

  loadFollowHistoryDetails,
  loadFollowHistoryDetailsSuccess,
  loadFollowHistoryDetailsError,

  loadFollowCronDetails,
  loadFollowCronDetailsSuccess,
  loadFollowCronDetailsError,
}

export default actions
